export default function formatCurrency(currency = 0) {
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
  }).format(currency / 100);
}
